import { CMS_LOCALES } from '../constants';
import { type CMSLocales } from '../types';

export function getCMSLocale(): CMSLocales {
  return CMS_LOCALES.en as CMSLocales;
}
